export const PERSONAL_WIN = 'PERSONAL_WIN';
export const PLAYER_WIN = 'PLAYER_WIN';
export const WINNERS_LIST = 'WINNERS_LIST';
export const PURCHASE = 'PURCHASE';
export const ERROR = 'ERROR';

export default { PERSONAL_WIN, PLAYER_WIN, WINNERS_LIST, PURCHASE, ERROR };